import React, { useContext, useState } from "react";
import packagesSvg from "./svgs/packages.svg";
import packageJSON from "../../../../package.json";

import { WarehouseProvider } from "./WarehouseProvider";
import AuthContext from "../../../contexts/AuthContext";
import { Snackbar, Fade } from "@mui/material";
import { TakebackQueueIcon } from "./components/TakebackQueueIcon";
import { PackageLookup } from "./PackageLookup";
import { useSteps } from "./useSteps";
import { BottomNav } from "./components/BottomNav";
import { Inventory } from "./Inventory";
import { Alerts } from "./Alerts";
import "./warehouse.css";

const { version } = packageJSON;

export const WarehousePackages = () => {
  const { StepComponent, props = {}, clear, resetToPackageLookup } = useSteps();
  const [showInventory, setShowInventory] = useState(false);
  const [showAlerts, setShowAlerts] = useState(false);
  const [initialTrackingId, setInitialTrackingId] = useState(null);

  // Clear initial tracking ID when component changes
  React.useEffect(() => {
    if (StepComponent && StepComponent !== PackageLookup) {
      setInitialTrackingId(null);
    }
  }, [StepComponent]);

  const { user } = useContext(AuthContext);
  const { successMessage } = props;

  return (
    <div className="warehouse-v2">
      <WarehouseProvider>
        {showInventory ? (
          <Inventory
            onBack={() => {
              setShowInventory(false);
              resetToPackageLookup();
            }}
            onAlertsClick={() => {
              setShowInventory(false);
              setShowAlerts(true);
            }}
            onRowClick={(trackingId) => {
              setInitialTrackingId(trackingId);
              setShowInventory(false);
              resetToPackageLookup();
            }}
          />
        ) : showAlerts ? (
          <Alerts
            onBack={() => {
              setShowAlerts(false);
              resetToPackageLookup();
            }}
            onInventoryClick={() => {
              setShowAlerts(false);
              setShowInventory(true);
            }}
            onRowClick={(trackingId) => {
              setInitialTrackingId(trackingId);
              setShowAlerts(false);
              resetToPackageLookup();
            }}
          />
        ) : StepComponent ? (
          <StepComponent
            {...props}
            initialTrackingId={initialTrackingId}
            onInventoryClick={() => setShowInventory(true)}
            onAlertsClick={() => setShowAlerts(true)}
          />
        ) : (
          <div className="flex items-center justify-center min-h-screen bg-[#030711]">
            <div className="absolute top-0 flex p-4 bg-[#1A2237] w-full h-[6rem] justify-between items-center">
              <div className="flex flex-row">
                <div className="text-2xl text-gray-400">v{version}</div>
              </div>
              <div className="flex flex-row justify-end gap-4">
                <div className="text-2xl text-gray-400">{user.email}</div>
                <TakebackQueueIcon />
              </div>
            </div>

            <div className="text-center font-sans p-4">
              <div className="flex flex-col items-center justify-center gap-4">
                <img
                  src={packagesSvg}
                  style={{ width: "6rem" }}
                  alt="Packages"
                />
                <span>
                  <h1 className="font-semibold text-6xl max-w-lg text-white">
                    Packages
                  </h1>
                  <p className="text-gray-400 text-2xl">
                    Check-in or process packages
                  </p>
                </span>

                <button
                  className="rounded-lg text-4xl bg-blue-600 hover:bg-blue-700 text-white px-x-large py-regular mt-large transition-colors"
                  onClick={() => {
                    resetToPackageLookup();
                  }}
                >
                  Start
                </button>
              </div>
            </div>
            <BottomNav
              activeTab=""
              onProcessingClick={() => {
                resetToPackageLookup();
              }}
              onInventoryClick={() => {
                setShowInventory(true);
              }}
              onAlertsClick={() => {
                setShowAlerts(true);
              }}
            />
          </div>
        )}
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "left" }}
          TransitionComponent={Fade}
          open={Boolean(successMessage)}
          onClose={clear}
          autoHideDuration={5000}
        >
          <div className="border-l-4 border-l-[#00CFA8] bg-[#00CFA8]/20 text-white p-4">
            {successMessage}
          </div>
        </Snackbar>
      </WarehouseProvider>
    </div>
  );
};
